import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

import { clubForDiscussion } from '../../common/clubs';

/**
 * "X wants to join your club", for the club's president and vices. Opens the
 * club discussion with the requests panel already showing.
 */
export default class ClubJoinRequestedNotification extends Notification {
  icon() {
    return 'fas fa-user-plus';
  }

  href() {
    const discussion = this.attrs.notification.subject();

    return app.route.discussion(discussion) + '?kulup=istekler';
  }

  content() {
    const discussion = this.attrs.notification.subject();
    const club = clubForDiscussion(discussion);

    return app.translator.trans('happydigital-clubs.forum.notifications.join_requested_text', {
      user: this.attrs.notification.fromUser(),
      club: club ? club.name : discussion.title(),
    });
  }

  excerpt() {
    return null;
  }
}
